<script>
  import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
  import { eventGroupState, isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
  import { projectState } from "@app/store/projectStore.svelte.js";
  import { createEventDispatcher } from "svelte";
  import { toast } from "@zerodevx/svelte-toast";
  import convertToPlainText from "@cclib/functions/quill/convertToPlainText.js";
  import voiceUtils from "@cclib/providers/textToSpeechAll/voiceUtils.js";
  import * as m from "@app/paraglide/messages.js";
  const dispatch = createEventDispatcher();
  let isLocked = $derived(isSelectedEventGroupLocked());

  function autoTimeEvents() {
    try {
      if (
        !eventGroupState[projectState.selected] ||
        eventGroupState[projectState.selected].selected.length === 0
      ) {
        return;
      }

      if (isSelectedEventGroupLocked()) {
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
      }

      eventGroupState[projectState.selected].selected
        .sort()
        .forEach((eventIndex) => {
          try {
            let startTime = (eventGroupState[projectState.selected].events[eventIndex-1]?.end ||  eventGroupState[projectState.selected].events[eventIndex].start || 0.1) + 0.5;

            let duration = voiceUtils.effectiveAudioDuration(eventGroupState[projectState.selected].events[eventIndex]) || convertToPlainText(eventGroupState[projectState.selected].events[eventIndex].text, "").length/25;
            
            eventGroupState[projectState.selected].events[eventIndex].start = startTime;
            eventGroupState[projectState.selected].events[eventIndex].end = startTime + duration;            
          } catch (err) {
            console.log(err, err.message);
          }
        });

      insertHistoryAction({
        name: "adjust duration", //action name
        eventGroup: projectState.selected,
        snapshots: [
          {
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState),
          },
        ],
      });
    } catch (err) {
      console.log(err);
      console.log(err.message);
    } finally {
      dispatch("done");
    }
  }
</script>

<a id="btnAutoTime"
   role="menuitem"
   aria-label={m.context_menu_auto_time_audio_label()}
   aria-disabled={isLocked}
   class="dropdown-item" class:disabled={isLocked} href="#!/" onclick={autoTimeEvents}
  >{m.context_menu_auto_time_audio()}</a
>
